import {Component} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute} from "@angular/router";
import {Clipboard} from "@angular/cdk/clipboard";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {CsApiService} from "../../api/cs-api.service";
import {CsLevelDto, CsLevelOptionDto, CsOverviewDto} from "../../types/cs.types";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";

@Component({
  selector: 'ci-interaction-types-page',
  templateUrl: './refer.page.html',
  styleUrls: ['./refer.page.scss']
})
export class ReferPage extends CorePage {

  override defaultLabel: string = "Refer Page";

  overviewDto: CsOverviewDto | undefined;

  //referFriendText: string | undefined;
  referDialog: boolean = false;
  redeemDialog: boolean = false;

  selectedLevel: CsLevelDto | undefined;
  selectedLevelOptionId: number | undefined;

  constructor(
    protected override route: ActivatedRoute,
    protected clipboardService: Clipboard,
    protected userApiService: UserApiService,
    protected messageService: AppMessageService,
    protected csApiService: CsApiService
  ) {
    super(route);

  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();

  }

  initComponent() {

    // retrieve the overview
    this.csApiService.getOverview().subscribe(value => {
      this.overviewDto = value;
      this.initialized = true;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService)
    });

  }



  navigateToWhatsApp() {
    const encodedText = encodeURIComponent(this.overviewDto?.texts.referralMessageText as string);
    window.open(`https://wa.me/?text=${encodedText}`, '_blank');
  }

  navigateToMessenger() {
    this.handleCopyClipboard();
    window.open('https://m.me/', '_blank');
  }

  handleCopyClipboard() {
    this.clipboardService.copy(this.overviewDto?.texts.referralMessageText as string);
    this.messageService.showInfoMessage('', 'Link kopiert')
  }


  navigateToFacebook() {
    const urlToShare = this.overviewDto?.texts.referralLink;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare as string)}`;
    window.open(facebookShareUrl, '_blank');
  }

  navigateToTelegram() {
    const baseUrl = "https://t.me/share/url";
    const urlToShare = this.overviewDto?.texts.referralLink;
    const textToShare = this.overviewDto?.texts.referralMessageText;
    const telegramUrl = `${baseUrl}?url=${encodeURIComponent(urlToShare as string)}&text=${encodeURIComponent(textToShare as string)}`;

    window.open(telegramUrl, '_blank');
  }

  onHideDialog() {
    this.redeemDialog = false;
  }
  // selectedLevel: CsLevelDto
  onShowRedeemDialog(level: CsLevelDto) {
    this.selectedLevel= level;
    this.redeemDialog = true;
  }

  onShowDialog(level: CsLevelDto) {
    this.selectedLevel = level;

    if (this.selectedLevel.selectedOption) {
      this.selectedLevelOptionId = this.selectedLevel.selectedOption.id;
    }

    this.referDialog = true
  }

  refreshOverview(overview: CsOverviewDto) {

    this.overviewDto = overview;

    if (this.selectedLevel) {
      if (this.overviewDto) {

        const currentSelectedLevelId = this.selectedLevel.id;
        this.selectedLevel = undefined;

        for (let level of this.overviewDto.levels) {
          if (level.id == currentSelectedLevelId) {
            this.selectedLevel = level;
            break;
          }
        }

        if (this.selectedLevel && this.selectedLevel.selectedOption) {
          this.selectedLevelOptionId = this.selectedLevel.selectedOption.id;
        }

      }
    }

  }

  saveSelection() {

    if (!this.selectedLevel) {
      return;
    }

    if (!this.selectedLevelOptionId) {
      return;
    }

    this.busy = true;
    this.csApiService.selectOption(this.selectedLevel.id, this.selectedLevelOptionId).subscribe(value => {
      this.overviewDto = value;
      this.referDialog = false;
      this.busy = false;
    }, error => {
      this.busy = false;
    });
  }

  redeem(level: CsLevelDto) {

    if (!this.overviewDto) {
      return;
    }

    if (level.requiredCount > this.overviewDto.score.remainingReferralCount) {
      return;
    }

    if (this.busy) {
      return;
    }

    if (!level.selectedOption) {
      return;
    }

    this.busy = true;
    this.csApiService.redeem(level.selectedOption.id).subscribe(value => {
      this.overviewDto = value;
      this.busy = false;
    }, error => {
      this.busy = false;
    });

    this.redeemDialog = false;

  }


}
